import axios from 'axios';

const API_URL = process.env.REACT_APP_API_URL + '/api/auth/';
// Admin girişi yap
const login = async (userData) => {
  const response = await axios.post(API_URL + 'login', userData);

  if (response.data) {
    // Gelen kullanıcı bilgisini ve token'ı tarayıcı hafızasına kaydet
    localStorage.setItem('userInfo', JSON.stringify(response.data));
  }

  return response.data;
};

// Çıkış yap
const logout = () => {
  localStorage.removeItem('userInfo');
};

const authService = {
  login,
  logout,
};

export default authService;